import { render, staticRenderFns } from "./SilomQueueDisplay.vue?vue&type=template&id=61d3c75a&scoped=true"
import script from "./SilomQueueDisplay.vue?vue&type=script&lang=js"
export * from "./SilomQueueDisplay.vue?vue&type=script&lang=js"
import style0 from "./SilomQueueDisplay.vue?vue&type=style&index=0&id=61d3c75a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61d3c75a",
  null
  
)

export default component.exports